import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import '../assets/styles/agGrid.css'
import sliderFilterIcon from '../assets/images/slider.webp'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import axios from 'axios'
import parse from 'html-react-parser';
import { useDispatch } from 'react-redux'
import { setShowEnquireModal, setEnquiryProduct } from '../context/data/modalSlice'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import SortableColumnHeader from '../components/SortableColumnHeader';
import useDebounce from "../hooks/useDebounce";
import handleErrors from '../utils/handleErrors';
import CustomNumberFilter from './filters/CustomNumberFilter';
import CustomStringFilter from './filters/CustomStringFilter';
import CustomRangeFilter from './filters/rangeFilter/CustomRangeFilter';
import CustomCheckListFilter from './filters/CustomCheckListFilter';

const ParseDisplayName = ({ displayName }) => <span style={{ color: '#ffffff' }}>{parse(displayName.replace(' ', '&nbsp;'))}</span>

const Device = ({ data, fieldGroupName }) => {
  const deviceName = data[Object.keys(data).filter(key => key.indexOf(`${fieldGroupName}__`) === 0)[0]]
  return (
    <div className="deviceCompMainDiv">
      <div className='paragraphLink'>
        <Link
          to={`/${data.categoryId}/${data.subcategoryId}/${typeof deviceName === 'object' ? deviceName.data : deviceName}`}
        >
          {typeof deviceName === 'object' ?
            <>{deviceName.data}<sup>{deviceName.annotation}</sup></> : deviceName}
        </Link>
      </div>
    </div>
  )
}

const Grid = ({
  industryFlag = false,
  categorySelect,
  setCategorySelect,
  subcategorySelect,
  setSubcategorySelect,
  apiParams,
  setApiParams,
  gridRef
}) => {
  const navigate = useNavigate()
  const params = useParams()
  const dispatch = useDispatch()
  const gridUseRef = useRef(null)
  const [firstTwoUpdates, setFirstTwoUpdates] = useState(2)
  const [searchBoxValue, setSearchBoxValue] = useState("")
  const debouncedSearchBoxValue = useDebounce(searchBoxValue)
  const { categoryName } = params
  const [queryParams, setQueryParams] = useSearchParams()
  const [categoryInfo, setCategoryInfo] = useState(null)
  const [categories, setCategories] = useState([])
  const [subcategories, setSubcategories] = useState([])
  const [annotationsData, setAnnotationsData] = useState([])
  const [units, setUnits] = useState([])
  const [packages, setPackages] = useState([])
  const [receivedUnitCategorySubcategoryPackage, setReceivedUnitCategorySubcategoryPackage] = useState(false)
  const [headerTop, setHeaderTop] = useState(null);

  // Set custom filter icon
  const gridOptions = {
    icons: {
      filter: `<img src="${sliderFilterIcon}" style="width: 16px; height: 16px;" alt="Filter" />`,
    },
  }
  const onGridReady = () => {
    const headerEl = document.querySelector('.ag-header')?.getBoundingClientRect();
    setHeaderTop(headerEl.top);
  }

  useEffect(() => {
    setApiParams(oldParams => ({ ...oldParams, searchParams: debouncedSearchBoxValue }))
  }, [debouncedSearchBoxValue])

  useEffect(() => {
    if (!headerTop) return;
    window.addEventListener('scroll', isSticky);
    return () => { window.removeEventListener('scroll', isSticky) };
  }, [headerTop]);

  const isSticky = () => {
    const headerEl = document.querySelector('.ag-header');
    const horizontalScrollEl = document.querySelector('.ag-body-horizontal-scroll')
    const paginationEl = document.querySelector('.ag-paging-panel').getBoundingClientRect()

    if (gridUseRef.current.getBoundingClientRect().top <= 0) {
      headerEl.classList.add('sticky')
    }
    else { headerEl.classList.remove('sticky') }

    if (paginationEl.top >= window.innerHeight)
      horizontalScrollEl.classList.add('stick-to-bottom')
    else
      horizontalScrollEl.classList.remove('stick-to-bottom')
  }

  const commonFieldKeys = (field, id, isSortable, headerName) => ({
    field,
    id,
    headerComponent: SortableColumnHeader,
    headerComponentParams: {
      apiParams,
      isSortable,
      setApiParams,
      columnId: id,
      headerName
    },
  })

  useEffect(() => {
    const getData = async () => {
      try {
        if (!receivedUnitCategorySubcategoryPackage) return;

        const { categoryName, subcategoryName } = params
        if (!categoryName || categoryName === 'all') {
          params.categoryId = 0
          params.subcategoryId = 0
          params.categoryName = 'all'
          params.subcategoryName = 'all'
        }
        else if (!subcategoryName || subcategoryName === 'all') {
          params.categoryId = categories
            .find(category => category.categoryName === params.categoryName)
            .categoryId
          params.subcategoryId = 0
          params.subcategoryName = 'all'
        }
        else {
          params.categoryId = categories
            .find(category => category.categoryName === params.categoryName)
            .categoryId
          params.subcategoryId = subcategories
            .find(subcategory => subcategory.subcatName === params.subcategoryName)
            .subcatId
        }

        const getTableData = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_BACKEND_URL}/frontend/product`,
          params: {
            apiParams: JSON.stringify(apiParams),
            params,
            industryParams: queryParams.get('industry')
          }
        })

        const newColDefArray = []
        const {
          subcatFgMap, fieldGroupFieldMap, fieldGroupData, fieldsData,
          packageThumbnails, products, productFieldsValues, productTotalCount, annotations
        } = getTableData.data

        setAnnotationsData(annotations)

        //  set the column definitions
        const uniqueFieldGroups = [...new Set(
          subcatFgMap
            .sort((a, b) => a.ordering - b.ordering)
            .map(obj => obj.fieldGroupId)
        )]

        if (uniqueFieldGroups.length > 0) {
          uniqueFieldGroups.forEach((fieldGroupId) => {
            const fieldsArray = []
            const findFieldGroup = fieldGroupData.find(obj => obj.id === fieldGroupId)

            if (findFieldGroup.fieldGroupName.indexOf('device') === 0) {
              const findDeviceField = fieldsData
                .find(obj => obj.fieldName.indexOf(`${findFieldGroup.fieldGroupName}__`) === 0)


           

               
           
                //Device Heading
              const fixedCols = [
                {
                  ...commonFieldKeys(findDeviceField.fieldName, findDeviceField.id, true, 'Device'),
                  width: 130,
                  suppressSizeToFit: true,
                  suppressAutoSize: true,
                  pinned: 'left',
                  cellRenderer: Device,
                  cellClass: 'device-cell',
                  cellStyle: {
                    fontWeight: 'bold',
                    borderRadius: '3px',
                    color: '#000',
                  },
                  cellRendererParams: { fieldGroupName: findFieldGroup.fieldGroupName }
                },
                ...(params.categoryName === 'all' ? [{
                  ...commonFieldKeys('categoryId', -100, true, 'Category'),
                  width: 160,
                  suppressSizeToFit: true,
                  suppressAutoSize: true,
                  cellRenderer: ({ data }) => <>
                    {categories.find(category => category.categoryId === data.categoryId)?.categoryName}
                  </>,
                  filter: CustomStringFilter,
                  filterParams: { setApiParams },
                  floatingFilter: true,
                }] : []),
                ...(!params.subcategoryName || params.subcategoryName === 'all' ? [{
                  ...commonFieldKeys('subcategoryId', -200, true, 'Subcategory'),
                  width: 240,
                  suppressSizeToFit: true,
                  suppressAutoSize: true,
                  cellRenderer: ({ data }) =>
                    subcategories.find(subcategory => subcategory.subcatId === data.subcategoryId)?.subcatName,
                  filter: CustomStringFilter,
                  filterParams: { setApiParams },
                  floatingFilter: true,
                }] : []),
                {
                  ...commonFieldKeys('packages', -300, true, 'Packages'),
                  width: 110,
                  suppressSizeToFit: true,
                  suppressAutoSize: true,
                  cellRenderer: ({ data }) => {
                    const findPackageThumbnail = packageThumbnails?.find(obj => obj.packageId === data?.packageId)
                    return (
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ display: "flex", alignItems: "center" }}>{packages.find(pkg => pkg.packageId === data.packageId)?.packageName}</span>
                        <img
                          src={`data:${findPackageThumbnail?.imageType};base64,${findPackageThumbnail?.imageFile}`}
                          alt=""
                          style={{ height: '32px' }}
                        />
                      </div >
                    )
                  },
                  filter: CustomCheckListFilter,
                  filterParams: { setApiParams, packageData: packageThumbnails },
                  floatingFilter: true,
                },
                {
                  ...commonFieldKeys('pdfDataSheet', -400, false, '<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align:middle"><title>Datasheet</title><path d="M7 1V10M7 10L3.5 6.5M7 10L10.5 6.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 13H13" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>'),
                  width: 58,
                  suppressSizeToFit: true,
                  suppressAutoSize: true,
                  cellRenderer: ({ data }) => {
                    if (!data.pdfDataSheet) return null;
                    return (
                      <div
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', cursor: 'pointer' }}
                        onClick={async () => {
                          try {
                            const response = await axios({
                              method: 'GET',
                              url: `${process.env.REACT_APP_BACKEND_URL}/frontend/product/pdfDataSheet`,
                              params: { pdfDataSheet: data.pdfDataSheet },
                              responseType: 'blob',
                            })
                            window.open(URL.createObjectURL(new Blob([response.data], { type: response.data.type })), '_blank')
                          } catch (error) {
                            handleErrors({ error })
                          }
                        }}
                      >
                        <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 1H2C1.44772 1 1 1.44772 1 2V15C1 15.5523 1.44772 16 2 16H12C12.5523 16 13 15.5523 13 15V6L8 1Z" stroke="#034EA2" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M8 1V6H13" stroke="#034EA2" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                          <text x="2.5" y="13" fontSize="4.5" fill="#034EA2" fontFamily="Consolas,monospace" fontWeight="bold">PDF</text>
                        </svg>
                      </div>
                    )
                  },
                }
              ]
              newColDefArray.unshift(...fixedCols)
            }
            else if (params.subcategoryName !== 'all') {
              fieldGroupFieldMap
                .filter(obj => obj.fieldGroupId === fieldGroupId)
                .sort((a, b) => a.ordering - b.ordering)
                .forEach((fieldgroupField) => {
                  const findField = fieldsData.find(obj => obj.id === fieldgroupField.fieldId)
                  const findUnit = units.find(obj => obj.id === findField.unitId)?.symbol
                  fieldsArray.push({
                    ...commonFieldKeys(findField.fieldName, findField.id, true,
                      `${findField.fieldLabel?.trim().length > 0 ? `${findField.fieldLabel} ` : ''}
                        ${findUnit ? `(${findUnit})` : ''}`
                    ),
                    minWidth: 60,
                    maxWidth: 130,
                    fieldValueType: findField.type,
                    cellDataType: 'text',
                    cellStyle: ['integer', 'float'].includes(findField.type) ? { textAlign: 'right' } : undefined,
                    headerClass: ['integer', 'float'].includes(findField.type) ? 'ag-right-aligned-header' : undefined,
                    filter: ['varchar', 'enum', 'enumMulti'].includes(findField.type) ?
                      findField.type === 'varchar' ? CustomStringFilter : false :
                      ((findField.type == 'integer' || findField.type == 'float') ? CustomRangeFilter : CustomNumberFilter)
                    ,
                    filterParams: { setApiParams },
                    floatingFilter: true,
                    fieldData: findField,
                    cellRenderer: (params) =>
                      <>
                        {typeof params.value === 'object' ?
                          <>{params.value.data}<sup className='annotationColor'>{params.value.annotation}</sup></>
                          :
                          params.value
                        }
                      </>,
                  })
                })
              const newColObject = {
                groupName: findFieldGroup.fieldGroupName,
                headerName: findFieldGroup.fieldGroupLabel,
              }

              if (fieldsArray.length > 0) {
                newColObject.headerGroupComponent = ParseDisplayName
                newColObject.children = fieldsArray
              }
              else newColObject.headerComponent = ParseDisplayName
              newColDefArray.push(newColObject)
            }
          })
          if (params.subcategoryName === 'all' && params.categoryName !== 'all') {
            newColDefArray.push({
              headerName: 'Select a subcategory to see full parametric data',
              headerGroupComponent: ({ displayName }) => (
                <div style={{ paddingLeft: '0.75rem', color: '#ffffff', fontWeight: 500, fontSize: '1.05rem', fontFamily: 'Consolas' }}>
                  {displayName}
                </div>
              ),
              children: [{
                field: '__hint__',
                flex: 1,
                headerName: '',
                sortable: false,
                filter: false,
                resizable: false,
                cellRenderer: () => null,
              }]
            })
          }
          setColDefs(newColDefArray)

          // Set the row data
          const localRowData = []
          const annotationsInThisTable = new Set();

          for (let i = 0; i < products.length; i++) {
            const product = products[i]
            const record = {}
            productFieldsValues
              .filter(obj => obj.productId === product.id)
              .map(obj => {
                if (obj.annotationId) {
                  if (obj.value || obj.charValue) {
                    record[fieldsData.find(field => field.id === obj.fieldId).fieldName] = {
                      data: obj.value || obj.charValue,
                      annotation: annotations.find(anno => anno.id === obj.annotationId).symbol
                    }
                  }
                  annotationsInThisTable.add(annotations?.find(anno => anno.id === obj.annotationId))
                }
                else if (obj.value || obj.charValue) {
                  record[fieldsData.find(field => field.id === obj.fieldId).fieldName] = obj.value || obj.charValue
                }
              });

            ['id', 'categoryId', 'subcategoryId', 'packageId', 'productUrl', 'pdfDataSheet']
              .forEach(key => record[key] = product[key])
            localRowData.push(record)
          }

          setAnnotationsData([...annotationsInThisTable])
          setRowData([
            ...Array.from({ length: apiParams.page * apiParams.itemsPerPage }, () => ({})),
            ...localRowData,
            ...Array.from({ length: productTotalCount - ((apiParams.page + 1) * apiParams.itemsPerPage) }, () => ({})),
          ])
        } else {
          setColDefs([])
          setRowData([])
        }
        setDataLoaded(true)
      } catch (error) {
        console.log("Error in get table data: ", error)
        handleErrors({ error })
      }
    }

    if (firstTwoUpdates > 0) {
      setFirstTwoUpdates(firstTwoUpdates - 1);
      return;
    }
    getData()
  }, [receivedUnitCategorySubcategoryPackage, apiParams, params, queryParams])

  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    const getCategoryInfo = async () => {
      try {
        if (categoryName !== 'all') {
          const findCategory = await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_URL}/frontend/category/find`,
            params: { categoryName }
          })

          if (!findCategory.data.found) navigate('/')
          setCategoryInfo(findCategory.data.categoryInfo)
        }
      } catch (error) {
        console.log("Error in find category: ", error)
        handleErrors({ error })
      }
    }

    if (categoryName) getCategoryInfo()
  }, [categoryName])

  useEffect(() => {
    const getAllCategoriesAndSubcategories = async () => {
      try {
        const resultOfGetAllCategories = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_BACKEND_URL}/frontend/category/all`,
        })
        setCategories(resultOfGetAllCategories.data.rows)

        const resultOfGetAllSubcategories = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_BACKEND_URL}/frontend/subcategory/all`,
        })
        setSubcategories(resultOfGetAllSubcategories.data.rows)
      } catch (error) {
        console.log("Error in getAllCategoriesAndSubcategories: ", error)
        handleErrors({ error })
      }
    }

    const getUnits = async () => {
      try {
        const result = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_BACKEND_URL}/frontend/unit/all`,
        })
        setUnits(result.data.rows)
      } catch (error) {
        console.log("error in getUnits: ", error)
        handleErrors({ error })
      }
    }

    const getPackages = async () => {
      try {
        const result = await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_BACKEND_URL}/frontend/packages`,
        })

        setPackages(result.data.data)
      } catch (error) {
        console.log("error in getPackages: ", error)
        handleErrors({ error })
      }
    }

    getAllCategoriesAndSubcategories()
    getUnits()
    getPackages()
  }, [])

  useEffect(() => {
    if (units.length > 0 && categories.length > 0 && subcategories.length > 0 && packages.length > 0)
      setReceivedUnitCategorySubcategoryPackage(true)
  }, [units, categories, subcategories, packages])

  const defaultColDef = useMemo(() => ({
    sortable: false,
    filter: false,
    resizable: true,
  }), [])

  const onFilterTextBoxChanged = () => {
    const filterTextValue = document.getElementById("search-box").value
    if (![',', ' '].includes(filterTextValue[filterTextValue.length - 1])) {
      setSearchBoxValue(filterTextValue)
    }
  }

  const onPaginationChanged = () => {
    const currentGridPage = gridRef.current.api.paginationGetCurrentPage()
    const currentGridPageSize = gridRef.current.api.paginationGetPageSize()
    if (apiParams.page !== currentGridPage || apiParams.itemsPerPage !== currentGridPageSize) {
      setApiParams(oldParams => ({
        ...oldParams,
        page: currentGridPage,
        itemsPerPage: currentGridPageSize,
      }))
    }
  }

  const paginationPageSizeSelector = useMemo(() => [25, 50, 75, 100], [])
  const paginationNumberFormatter = useCallback(params => params.value.toLocaleString(), [])

  const customStyles = `
    .ag-theme-alpine .ag-row:nth-child(even) { background-color: #F0EBE1; }
    .ag-theme-alpine .ag-row:nth-child(odd)  { background-color: #ffffff; }
    .ag-theme-alpine .ag-row:hover           { background-color: rgba(253, 185, 19, 0.5) !important; }
  `;

  return (
    <div className='gridParent'>
      
      <div className="gridDiv">
        <div className="byLineDiv">
          {industryFlag === false ?
            <>
            
              <div className='categoryDiv'>
                <div  style={{fontSize:'medium',fontWeight: 'bold'}}>Category</div>
                <select
                  id="categorySelect"
                  name="categorySelect"
                  value={categorySelect}
                  onChange={(e) => { setCategorySelect(e.target.value) }}
                  style={{
                    padding: '8px 12px',
                    fontSize: '14px',
                    border: '1px solid #9E9E9E',
                    borderRadius: '6px',
                    minWidth: '200px',
                    backgroundColor: 'white',
                    color: 'rgb(51, 51, 51)',
                    outline: 'none',
                    boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3)',
                  }}
                >
                  <option value="all">Select a Category</option>
                  {categories?.map((category) => (
                    <option value={category.categoryName}>{category.categoryName}</option>
                  ))}
                </select>
              </div>
              <div className='subcategoryDiv'>
                <div style={{fontSize:'medium',fontWeight: 'bold'}}>Subcategory</div>
                <select id="subcategorySelect"
                  name="subcategorySelect"
                  disabled={categorySelect === 'all'}
                  value={subcategorySelect}
                  onChange={(e) => setSubcategorySelect(e.target.value)}
                  style={{
                     padding: '8px 12px',
                    fontSize: '14px',
                    border: '1px solid #9E9E9E',
                    borderRadius: '6px',
                    minWidth: '200px',
                    backgroundColor: 'white',
                    color: 'rgb(51, 51, 51)',
                    outline: 'none',
                    boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3)',
                    
                  }}
                 >
                  <option value="all">Select a Subcategory</option>
                  {subcategories?.filter(subcategory => subcategory.catId === categoryInfo?.categoryId)
                    .map((subcategory) => (
                      <option value={subcategory.subcatName}>{subcategory.subcatName}</option>
                    ))}
                </select>
              </div>
            </>
            :
            <></>
          }
          <div className='searchBoxDiv'>
            <div style={{fontSize:'medium',fontWeight: 'bold'}}>Searchbox</div>
            <input
              type="text"
              id="search-box"
              placeholder="Enter search device..."
              autoComplete='off'
              onInput={onFilterTextBoxChanged}
              style={{
                 padding: '8px 12px',
                    fontSize: '14px',
                    border: '1px solid #9E9E9E',
                    borderRadius: '6px',
                    minWidth: '200px',
                    backgroundColor: 'white',
                    color: 'rgb(51, 51, 51)',
                    outline: 'none',
                    boxShadow: '0 15px 40px rgba(0, 0, 0, 0.3)',
                    height: '36.78px'
              }}
            />
          </div>
        </div>
        <style>{customStyles}</style>
        <div style={{ position: 'relative' }}>
          <div
            ref={gridUseRef}
            className='ag-theme-alpine grid-container'
            id="referenceGridStart"
            style={{ width: '100%', fontFamily: 'Poppins_Light, system-ui, sans-serif' }}
          >
            <AgGridReact
              animateRows
              key={params.subcategoryName || params.categoryName}
              autoSizeStrategy={{ type: 'fitCellContents', defaultMinWidth: 60, defaultMaxWidth: 130 }}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              domLayout="autoHeight"
              enableColumnResizing="false"
              enableCellTextSelection
              ensureDomOrder
              headerHeight={20}
              gridOptions={gridOptions}
              groupHeaderHeight={25}
              floatingFiltersHeight={30}
              onGridReady={onGridReady}
              pagination
              paginationNumberFormatter={paginationNumberFormatter}
              paginationPageSize={25}
              paginationPageSizeSelector={paginationPageSizeSelector}
              onPaginationChanged={onPaginationChanged}
              ref={gridRef}
              rowData={rowData}
              rowHeight={35}
              suppressCellSelection
              suppressColumnVirtualisation
              suppressMenuHide
              suppressDragLeaveHidesColumns
            />
          </div>
        </div>

        {dataLoaded && rowData.length === 0 && (
          <div style={{ textAlign: 'center', padding: '48px 24px', color: '#6b7280', fontSize: '15px' }}>
            No products found for this selection.
          </div>
        )}

        {(rowData.length > 0 && annotationsData.length > 0) ?
          <div className='annotationsDiv'>
            <div>
              Key
              <table>
                {annotationsData?.map(anno => (
                  <tr>
                    <td>{anno.symbol}</td>
                    <td>{parse(anno.description)}</td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
          : <></>}
      </div>
    </div >
  )
}

export default Grid
